import { CompetitionSport } from './competition-sport'
import { Injectable } from '@angular/core'

@Injectable()
export class CompetitionSportSerializer {
  fromJson(json: any): CompetitionSport {
    const competitionSport = {
      ...json
    }

    return competitionSport
  }

  toJson(competitionSport: CompetitionSport): any {
    return {
      ...competitionSport
    }
  }
}
